export enum OnboardingDrawerStep {
  Onboarding = "Onboarding",
  Login = "Login",
  Register = "Register",
  ForgotSecret = "ForgotSecret",
  UpdateBankAccount = "UpdateBankAccount",
  UpdateLegalName = "UpdateLegalName",
}
